import { useEffect, useRef, useState } from "react";
import { Button, SVG } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";
import PostFormGroup from "../feed-form/PostFormGroup";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "services/redux/store";
import {
    setEngajmnetModalPostion,
    setIncident,
    setPost
} from "services/redux/feedForm/feedForm";
import { addPost } from "services/redux/postForm/postForm";
import IncidentFormGroup from "../feed-form/IncidentFormGroup";
import { addIncident } from "services/redux/incidentForm/incidentForm";
import { allowScroll, stopScroll } from "services/redux/site/site";
import RulesModel from "./RulesModel";
import ConfirmClosePost from "./ConfirmClosePost";
import DraftModal from "./DraftModal";

export type FeedPostModalProps = CustomComponentProps &
    GeneralModalProps & {
        setOpenEngajment: React.Dispatch<React.SetStateAction<boolean>>;
    };
const FeedPostModal = ({
    open,
    setOpen,
    setOpenEngajment,
    className,
    style
}: FeedPostModalProps) => {
    const [openRules, setOpenRules] = useState(false);
    const [openConfirmClose, setOpenConfirmClose] = useState(false);
    const [openDraft, setOpenDraft] = useState(false);

    const dispatch = useDispatch<AppDispatch>();

    const postGroup = useSelector(
        (state: RootState) => state.postForm.postGroup
    );

    // const [validPosts, setValidPosts] = useState(false);
    // const checkPostsValidity = () => {
    //     // eslint-disable-next-line
    //     for (let post of postGroup) {
    //         if (post.isValid == false) {
    //             setValidPosts(false);
    //             break;
    //         }
    //     }
    // };

    // useEffect(() => {
    //     checkPostsValidity();
    // }, [postGroup]);

    // toggle form type and post visibility
    const formType = useSelector((state: RootState) => state.feedForm.formType);
    const setFormType = (type: "post" | "incident") => {
        if (type == "post") {
            dispatch(setPost());
        } else {
            dispatch(setIncident());
        }
    };

    const handleAddPost = () => {
        if (formType == "post") {
            dispatch(addPost());
        } else {
            dispatch(addIncident());
        }
    };

    const visibility = useSelector(
        (state: RootState) => state.feedForm.visibility
    );
    const engajmentBtnRef = useRef(null);

    const handleOpenEngajmentModal = () => {
        // @ts-ignore
        const rect = engajmentBtnRef.current.getBoundingClientRect();
        console.log("rect", rect);
        const left = rect.left + 10;

        const parentElBottom = rect.bottom;
        const elHeight = 250;
        const windowHeight = window.innerHeight;
        let top = 0;
        if (parentElBottom + elHeight - 10 >= windowHeight) {
            top = parentElBottom - elHeight + 15;
        } else {
            top = parentElBottom + 5;
        }

        dispatch(setEngajmnetModalPostion({ left, top }));
        setOpenEngajment(true);
    };

    useEffect(() => {
        open ? dispatch(stopScroll()) : dispatch(allowScroll());
    }, [open]);

    return (
        <>
            <div
                id="post-modal"
                className={`modal is-small has-light-bg ${className} ${open ? "is-active" : ""}`}
                style={style}
            >
                <div className="modal-background"></div>
                <div className="modal-content">
                    <div className="card is-new-content">
                        <div className="card-heading">
                            <div className="tabs is-boxed is-fullwidth">
                                <ul id="post-form-tabs-ul">
                                    <li
                                        id="post-tab-li"
                                        className={`${formType == "post" ? "is-active" : ""}  post-form-tabs-li`}
                                        onClick={() => setFormType("post")}
                                        //   onclick="togglePostIncident('post')"
                                    >
                                        <a className="grey-text">
                                            <span className="icon is-small grey-text">
                                                <SVG
                                                    svg="pen"
                                                    size={16}
                                                    className="light-grey-svg"
                                                />
                                            </span>
                                            <span className="grey-text">
                                                Post
                                            </span>
                                        </a>
                                    </li>
                                    <li
                                        id="incident-tab-li"
                                        className={`${formType == "incident" ? "is-active" : ""}  post-form-tabs-li`}
                                        onClick={() => setFormType("incident")}
                                    >
                                        <a className="grey-text">
                                            <span className="icon is-small">
                                                <SVG
                                                    svg="i-triangle"
                                                    size={16}
                                                    className="light-grey-svg"
                                                />
                                            </span>
                                            <span>Incident</span>
                                        </a>
                                    </li>
                                    <li className="close-wrap d-flex flex-j-end mr-10">
                                        <button
                                            className="button is-solid is-primary primary-btn close-modal draft-btn"
                                            onClick={() => setOpenDraft(true)}
                                            style={{
                                                padding: "10px 30px",
                                                borderRadius: "0.65rem"
                                            }}
                                        >
                                            Draft
                                        </button>
                                        <span
                                            className="close-modal"
                                            onClick={() =>
                                                setOpenConfirmClose(true)
                                            }
                                        >
                                            <SVG svg="x" size={16} />
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="card-body">
                            {/* {{-- post form part --}} */}
                            {formType == "post" ? (
                                <PostFormGroup postGroup={postGroup} />
                            ) : (
                                ""
                            )}
                            {/* {{-- / post form part --}} */}

                            {/* {{-- incident form part --}} */}
                            {formType == "incident" ? (
                                <IncidentFormGroup />
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="card-footer d-flex flex-j-between pt-10">
                            <div className="d-flex flex-j-start flex-a-center gap-10">
                                <div
                                    className="modal-trigger momeento-p selected-value d-flex flex-a-center gap-5 cursor-pointer"
                                    onClick={handleOpenEngajmentModal}
                                    ref={engajmentBtnRef}
                                >
                                    {visibility == "Everyone" ? (
                                        <>
                                            <SVG svg="globe" size={16} />
                                            <span>Everyone</span>
                                        </>
                                    ) : visibility == "People You Follow" ? (
                                        <>
                                            <SVG svg="user-check" size={16} />
                                            <span>People You Follow</span>
                                        </>
                                    ) : (
                                        <>
                                            <SVG svg="community" size={16} />
                                            <span>Community</span>
                                        </>
                                    )}
                                    {/* <div className="svg-16 momeento-svg globe-svg"></div>
                                    <span>Everyone</span> */}
                                </div>
                                {formType == "incident" ? (
                                    <div
                                        className="d-flex flex-j-start flex-a-center gap-5"
                                        onClick={() => setOpenRules(true)}
                                    >
                                        <SVG
                                            svg="read-book-alt"
                                            size={24}
                                            className="blue-white-svg"
                                        />
                                        <p className="momeento-p cursor-pointer">
                                            Rules
                                        </p>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>

                            <div className="button-wrap d-flex flex-j-center flex-a-center gap-5">
                                <span
                                    id="post-plus"
                                    className="plus-btn cursor-pointer d-flex flex-a-center"
                                    //   onclick="createSubPost()"
                                    onClick={handleAddPost}
                                >
                                    <SVG
                                        svg="plus-circle"
                                        size={24}
                                        className="blue-svg"
                                    />
                                </span>
                                <button
                                    type="button"
                                    className="button is-solid is-primary primary-btn close-modal"
                                >
                                    Publish
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* emoji modal */}
            {/* <EmojiModal /> */}
            {/* rules model */}
            <RulesModel open={openRules} setOpen={setOpenRules} />
            {/* add confirm close modal */}
            <ConfirmClosePost
                open={openConfirmClose}
                setOpen={setOpenConfirmClose}
                closePostModal={setOpen}
            />
            <DraftModal open={openDraft} setOpen={setOpenDraft} />
        </>
    );
};

export default FeedPostModal;
